<template>
  <div class="file-list d-flex flex-wrap">
    <File
      v-for="(file, index) in fileList"
      :key="index"
      :fileName="file.file_name"
      :fileSize="file.display_file_size"
      @click="handleClick(file.id)"
    />
  </div>
</template>

<script>
import File from './File'

export default {
  name: 'AttachedFileList',

  components: {
    File
  },

  props: {
    fileList: {
      default() {
        return []
      }
    }
  },

  methods: {
    handleClick(fileId) {
      this.$emit('click', fileId)
    }
  }
}
</script>

<style scoped>
.file-list a {
  margin: 3px;
}
</style>
